import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';

type ActivateAutomatedCampaignPayload = {
  MarketingCampaignId: number;
};
export function useActivateAutomatedMarketingCampaignMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ActivateAutomatedCampaignPayload) => {
      await postData<ActivateAutomatedCampaignPayload>({
        endpoint: 'api/marketing-campaign/activate-automated-campaign',
        payload,
      });
    },
    onSuccess: () => queryClient.invalidateQueries(marketingCampaignsQueryKey),
  });
}
